"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface FunnelStep {
  name: string;
  count: number;
  percentage: number;
}

interface FunnelChartProps {
  data: FunnelStep[];
}

export function FunnelChart({ data }: FunnelChartProps) {
  const colors = [
    "bg-blue-500",
    "bg-blue-400",
    "bg-emerald-500",
    "bg-emerald-400",
    "bg-green-500",
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Conversion Funnel</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {data.map((step, index) => (
          <div key={step.name} className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="font-medium">{step.name}</span>
              <span className="text-muted-foreground">
                {step.count} ({step.percentage}%)
              </span>
            </div>
            <div className="relative h-8 overflow-hidden rounded-md bg-muted">
              <div
                className={`absolute inset-y-0 left-0 ${colors[index] || "bg-blue-500"} transition-all duration-500`}
                style={{ width: `${step.percentage}%` }}
              />
              <div className="absolute inset-0 flex items-center justify-center text-xs font-medium">
                {step.percentage > 10 && (
                  <span className="text-white drop-shadow-sm">
                    {step.count}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
